import React from 'react';
import mapIcon from "../assets/images/typcn_location.png";
import mailIcon from "../assets/images/fluent_mail-20-filled.png";
import callIcon from "../assets/images/material-symbols_call-sharp.png";

// You might want to use Framer Motion for spring animation. Here's how you'd import it:
import { motion } from 'framer-motion';

export default function WeAreMoreThanInternational() {
    return (
        <div className='relative flex justify-center items-center py-[6%] px-[8%]'>
            <div>
                <div>
                    {/* Heading with Animation */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: false }}
                        transition={{ duration: 1, ease: "easeOut" }}
                    >
                        <h2 className='px-6 text-[1.5rem] text-center font-extrabold leading-none text-[var(--primary-color)]'>
                            We're more than an International <br />
                            <span className='relative text-[var(--second-primary-color)]'>Exchange Platform</span>
                        </h2>
                    </motion.div>

                    {/* Contact info with Shake Animation */}
                    <div className="grid md:grid-cols-3 gap-10 pt-[10%] text-[#555D68] text-[.8rem] items-center">

                        <motion.div
                            className="flex bg-white gap-4 px-4 py-3 shadow-lg rounded-full w-full sm:w-auto items-center"
                            whileInView={{ x: 0 }}
                            initial={{ x: -10 }}
                            viewport={{once: false}}
                            transition={{ type: "spring", stiffness: 100, damping: 10, repeat: 0.5, repeatType: "reverse" }}
                        >
                            <div className='flex px-2 gap-4'>
                                <img className='w-[30px] h-[30px]' src={mapIcon} alt="location" />
                                <p>No. 90 George Akume Way <br />Makurdi, Benue, Nigeria</p>
                            </div>
                        </motion.div>

                        <motion.div
                            className="flex bg-white gap-4 px-4 py-3 shadow-lg rounded-full w-full sm:w-auto items-center"
                            whileInView={{ x: 0 }}
                            initial={{ x: 10 }}
                            viewport={{once: false}}
                            transition={{ type: "spring", stiffness: 100, damping: 10, repeat: 0.5, repeatType: "reverse" }}
                        >
                            <div className='flex px-2 gap-4'>
                                <img className='w-[30px] h-[30px]' src={mailIcon} alt="email" />
                                <p>hello@fastest.exchange <br />info@fastest.exchange</p>
                            </div>
                        </motion.div>

                        <motion.div
                            className="flex bg-white gap-4 px-4 py-3 shadow-lg rounded-full w-full sm:w-auto items-center"
                            whileInView={{ x: 0 }}
                            viewport={{once: false}}
                            initial={{ x: -10 }}
                            transition={{ type: "spring", stiffness: 100, damping: 10, repeat: 0.5, repeatType: "reverse" }}
                        >
                            <div className='flex px-2 gap-4'>
                                <img className='w-[30px] h-[30px]' src={callIcon} alt="call" />
                                <div>
                                    <p>+256 780 433 930</p>
                                    <p>+234 708 849 4910</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    );
}
